import { render } from "./ViewAccount.vue?vue&type=template&id=f182483a&scoped=true"
import script from "./ViewAccount.vue?vue&type=script&lang=js"
export * from "./ViewAccount.vue?vue&type=script&lang=js"

import "./ViewAccount.vue?vue&type=style&index=0&id=f182483a&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f182483a"]])

export default __exports__